import React, { useContext } from 'react';
import withCards, { CardContext } from 'hoc/withCards';
import ListFilter from 'components/common/list-filter/ListFilter';
import ReportCard from 'reports/components/ReportCard';
import { Report } from 'reports/types';
import ReportService from 'reports/services';
import { Link } from 'react-router-dom';
import { PermissionContext } from 'hoc/withPermission';

type Props = {
  renderLoading: () => React.ReactNode;
  onChangeForm: (e: any) => undefined;
};

const ReportListPage = ({ renderLoading, onChangeForm }: Props) => {
  const { hasPermission } = useContext(PermissionContext);

  return (
    <CardContext.Consumer>
      {({ cards }) => (
        <>
          {hasPermission('reports.add_sqlreport') && (
            <div className="mb-3">
              <Link className="btn btn-primary" to="/relatorios/new">
                CADASTRAR RELATÓRIO
              </Link>
            </div>
          )}
          <ListFilter onValueChange={(e) => onChangeForm(e)} />
          <div className="card-deck">
            {renderLoading() ||
              cards.map((card: Report) => (
                <ReportCard key={card.id} id={card.id} name={card.name} />
              ))}
          </div>
        </>
      )}
    </CardContext.Consumer>
  );
};

export default withCards({
  fetch: ReportService.list,
  title: 'Relatórios',
  paginated: true,
  noResultsText: 'Nenhuma relatório foi encontrado.',
})(ReportListPage);
